import { Typography } from "antd";
import clsx from "clsx";
import React, { memo } from "react";
import { useTranslation } from "react-i18next";

import Button from "@sol/uikit/general/Button";

import { simplonWebsiteUrl } from "../../../constants/externalLinks";

const LoginLayoutHero = ({ className }: { className?: string }) => {
    const [t] = useTranslation();

    return (
        <div className={clsx("relative flex w-full flex-col gap-ant", className)}>
            <div className="px-ant">
                <img
                    src="/static/logo-light-vertical.png"
                    alt="Simplonline"
                    className="hidden w-full self-center sm:block"
                />
                <img src="/static/logo-dark-vertical.png" alt="Simplonline" className="w-full self-center sm:hidden" />
            </div>
            <div className="mb-ant-xxl hidden flex-col gap-ant-xxs xl:flex">
                <Typography.Title className="!text-[var(--ant-color-white)] xl:inline-block" level={1}>
                    <span className="block text-left opacity-80">{t("layout.login.heroIntroduction")}</span>
                </Typography.Title>
                <Button
                    size="small"
                    target="_blank"
                    rel="noopener noreferrer"
                    href={simplonWebsiteUrl}
                    color="red"
                    variant="solid"
                    className="self-end rounded-full !px-ant"
                >
                    {t("page.login.hero.poweredBySimplon")}
                </Button>
            </div>
        </div>
    );
};

export default memo(LoginLayoutHero);
